import React from 'react';

import LatestBestSellers from '../LatestBestSellers/LatestBestSellers';

const ModuleLatestBestSellers = ({
  latest,
  bestSellers,
  loading,
  primaryColor,
  secondaryColor,
  uiVariantMenu,
  uiVariantThumbnail,
}) => {
  return (
    <LatestBestSellers
      latest={latest}
      bestSellers={bestSellers}
      loading={loading}
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      uiVariantMenu={uiVariantMenu}
      uiVariantThumbnail={uiVariantThumbnail}
    />
  );
};

export default ModuleLatestBestSellers;
